// Tiny prod-aware logger. In production builds (`import.meta.env.PROD === true`)
// debug + info calls are no-ops so we don't ship verbose logs — including
// PII like email subjects — to the browser console of every signed-in user.
// `warn` and `error` always pass through so genuine problems are still visible.

const isProd = !!import.meta.env.PROD;

function passthrough(level: 'log' | 'warn' | 'error') {
  return (...args: unknown[]) => {
    // eslint-disable-next-line no-console
    console[level](...args);
  };
}

export const logger = {
  debug: isProd ? (() => undefined) : passthrough('log'),
  info:  isProd ? (() => undefined) : passthrough('log'),
  warn:  passthrough('warn'),
  error: passthrough('error'),
};

export default logger;
